import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/**
 * Sentinel year value used to mark dates without a year.
 * Year 2400 is used because:
 * - It's far in the future (no real dates will have this year)
 * - It's a leap year (supports Feb 29)
 * - Easy to recognize in logs and debugging
 */
export const DATE_WITHOUT_YEAR_SENTINEL = 2400;

export const getDateTimeUSAFormat = (date: Date) => {
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
  };
  
export const firstLetterCamelCase = (str: string) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatDateWithoutTimezone(dateString: string) {
  const dateOnly = dateString.substring(0, 10);
  const date = new Date(dateOnly + 'T00:00:00.000Z');

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const formattedDate = year === DATE_WITHOUT_YEAR_SENTINEL ? `${month}/${day}/----` : `${month}/${day}/${year}`;
  return formattedDate;
}

export const getDateTimeUSAFormatWithTime = (date: Date) => {
  return dayjs(date).format('MM/DD/YYYY hh:mm A');
};

export const getTimePassed = (value: string | Date) => {
  return dayjs(value).fromNow(true);
};

// Only http(s), in any case: any other scheme gets `https://` in front, so the result never opens as
// `javascript://…` or `data://…`.
const URL_SCHEME = /^https?:\/\//i;

export const normalizeUrl = (input: string): string => {
  let normalized = (input || '').trim();
  if (!normalized) return '';
  if (normalized.startsWith('www.')) {
    normalized = 'https://' + normalized;
  } else if (!URL_SCHEME.test(normalized)) {
    normalized = 'https://' + normalized;
  }
  return normalized;
};

export const validateUrl = (value: string): boolean => {
  const normalized = normalizeUrl(value);
  try {
    new URL(normalized);
    return true;
  } catch {
    return false;
  }
};

export const normalizeString = (value?: string | null | undefined): string => (value ?? '').trim().toLowerCase();

export const isEqualStrings = (a: string | null | undefined, b: string | null | undefined): boolean => {
  return normalizeString(a) === normalizeString(b);
};
